import { TableSubviewStateProvider } from './table-subview-state-provider';
import { TableSubviewProps } from './table-subview.types';

export const TableSubview = (props: TableSubviewProps) => {
  const { children, defaultSelection, className, onSelect } = props;

  return (
    <TableSubviewStateProvider selectedId={defaultSelection} onSelectionChanged={onSelect}>
      <div className={`flex basis-0 gap-2 ${className}`}>{children}</div>
    </TableSubviewStateProvider>
  );
};
